import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact, { ReactAppOrParcel } from 'single-spa-react';
import { Component } from '../types';

function domElementGetter() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return document.getElementById('app')!;
}

export function createSingleSPA(config: {
  React: typeof React;
  ReactDOM: typeof ReactDOM;
  RootComponent: Exclude<Component, string>;
}): ReactAppOrParcel<Record<string, unknown>> {
  return singleSpaReact({
    React: config.React,
    ReactDOM: config.ReactDOM,
    rootComponent: config.RootComponent,
    domElementGetter,
  });
}
